<div class="modal-header">
    <h4 class="modal-title fw-bold">
        <span jhiTranslate="single-site-analysis.import.header">Upload Breeding View Output Files to BMS</span>
    </h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="dismiss()">
    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-md-12">
            <span jhiTranslate="single-site-analysis.import.label"></span>
        </div>
    </div>
    <br/>
    <div class="row mb-1">
        <div class="col-md-12">
            <span jhiTranslate="single-site-analysis.zip.label.text"></span>
        </div>
    </div>
    <div class="row mb-3">
        <div class="col-2"></div>
        <div class="col-md-8">
			<jhi-file-select id="fileUpload"
							 [acceptedFileTypes]="selectedFileType"
							 (fileSelected)="onFileChange($event)"
							 (fileCleared)="clearSelectedFile()">
			</jhi-file-select>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="dismiss()">
        <span jhiTranslate="cancel"></span>
    </button>
    <button (click)="import()" class="btn btn-primary" [disabled]="isLoading">
        <span *ngIf="isLoading" class="throbber throbber-btn"></span>
        <span jhiTranslate="single-site-analysis.button.upload">Upload</span>
    </button>
</div>
